import { useQuery } from '@tanstack/react-query';
import {
  Report,
  ReportsFilters,
  getReports,
  getReport,
  getPendingApprovals,
  PendingApprovalItem,
  PendingApprovalsFilters,
} from '../lib/reports';

/**
 * 보고서 목록 조회 훅
 */
export function useReports(
  companyId: string | undefined,
  filters?: ReportsFilters
) {
  return useQuery({
    // 조회 조건은 **전부** 키에 넣는다 — 빠진 축이 있으면 그 축만 바꿨을 때 react-query가
    // 이전 조건의 캐시를 그대로 내준다(검색어를 지웠는데 결과가 안 돌아오는 식).
    queryKey: [
      'reports',
      companyId,
      filters?.siteId,
      filters?.groupId ?? null,
      filters?.status,
      filters?.templateKey,
      filters?.search,
      filters?.mine,
      filters?.limit,
      filters?.offset,
    ],
    queryFn: async () => {
      const response = await getReports(companyId!, filters);
      return response;
    },
    enabled: !!companyId,
  });
}

/**
 * 보고서 상세 조회 훅
 */
export function useReport(
  reportId: string | undefined,
  companyId: string | undefined
) {
  return useQuery({
    queryKey: ['report', reportId],
    queryFn: () => getReport(reportId!, companyId!),
    enabled: !!reportId && !!companyId,
  });
}

/**
 * 결재 대기 목록 조회 훅
 */
export function usePendingApprovals(
  companyId: string | undefined,
  filters?: PendingApprovalsFilters
) {
  return useQuery({
    queryKey: [
      'pendingApprovals',
      companyId,
      filters?.siteId,
      filters?.groupId ?? null,
      filters?.myOnly,
    ],
    queryFn: () => getPendingApprovals(companyId!, filters),
    enabled: !!companyId,
  });
}

// Re-export types for convenience
export type { Report, ReportsFilters, PendingApprovalItem, PendingApprovalsFilters };
